import React from "react";
import "./org.css";
import { OrganisationsLinks } from "./Org.js";
function Altar () {
    return (
        <div class="content1">
            <OrganisationsLinks />
            <h2>Altar Boys</h2>
            <div class="org-portion">
                <div class="org-left">
                    <img src="/images/Logo.png" alt="Logo 2024 - 25" />
                </div>
                <div class="org-right">
                    <div class="org-descp">
                        <h4>Logo Name</h4>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!</p>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!</p>
                    </div>
                </div>
            </div>
            <div class="unit-group">
                <img src="/images/cat-gp.jpg" alt="Altar Boys Members" />
                <h3>Altar Boys Members</h3>
            </div>
            <div class="members-table" style={{ marginBottom: 0 }}>
                <table border="1">
                    <tr>
                        <th>Position</th>
                        <th>Name</th>
                        <th>Contact Number</th>
                    </tr>
                    <tr>
                        <td>President</td>
                        <td>Name 1</td>
                        <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                    </tr>
                    <tr>
                        <td>Vice President</td>
                        <td>Name 2</td>
                        <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                    </tr>
                    <tr>
                        <td>Secretary</td>
                        <td>Name 3</td>
                        <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                    </tr>
                    <tr>
                        <td>Treasurer</td>
                        <td>Name 4</td>
                        <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                    </tr>
                </table>
            </div>
            <div class="org-gallery">
                <hr></hr>
                <h5>Gallery</h5>
                <div class="org-boxesm">
                    <div class="org-iboxm">
                        <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                        <img src="/images/antony.jpg" alt="St. Antony's Church" />
                        <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                        <img src="/images/cat-gp.jpg" alt="St. Antony's Church" />
                    </div>
                    <div class="org-iboxm">
                        <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                        <img src="/images/antony.jpg" alt="St. Antony's Church" />
                        <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                        <img src="/images/cat-gp.jpg" alt="St. Antony's Church" />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Altar;